import React from 'react';

import './StateIncomeTaxDisclosure.scss';

import Button from '../../Shared/Button/Button';
import StateNotes from './StateNotes';
import { fullStateName } from '../../../utils/utils';
import If from 'src/components/Shared/If/If';
import { getWithholdingStateLookup } from '../../../redux/modules/stateWithholding/selectors';
import { useSelector } from 'react-redux';
import config from '../../../config/config';

const StateIncomeTaxDisclosure = ({
  closeStateIncomeTaxDisclosure,
  mandatoryWithholdingStates,
  nonMandatoryWithholdingStates,
  state,
  isSalesforceRepMessage,
}) => {
  const statesList = useSelector(getWithholdingStateLookup);
  const stateRules = statesList?.[state ?? ''] || {};
  return (
    <div className="e2e-state-withholding-warning-container">
      <If test={!isSalesforceRepMessage}>
        <div className="state-income-tax-disclosure-heading">
          State Income Tax Withholding Disclosure
        </div>
      </If>
      <If test={isSalesforceRepMessage}>
        <span className="state-income-tax-disclosure-leader">
          State Income Tax Withholding Disclosure
        </span>
      </If>
      <ul className="state-income-tax-disclosure-list">
        <If test={state !== 'IA'}>
          <li className="state-income-tax-disclosure-item">
            Your IRA is associated with an address in{' '}
            <span className="state-income-tax-disclosure-leader">
              {fullStateName(state)}
            </span>
            {state === 'MN' && (
              <span>
                , where state income tax withholding is{' '}
                <span className="state-income-tax-disclosure-leader">
                  {stateRules.percent}% of your redemption amount.
                </span>
              </span>
            )}
            {state === 'CT' && (
              <span>
                . We will withhold{' '}
                <span className="state-income-tax-disclosure-leader">
                  {stateRules.percent}% of your redemption amount{' '}
                </span>
                unless you direct us otherwise.
              </span>
            )}
            {state !== 'MN' && state !== 'CT' && (
              <span>
                , where state income tax withholding is
                <span className="state-income-tax-disclosure-leader">
                  {' '}
                  <span>
                    {stateRules.percent}% of{' '}
                    {state === 'VT' || state === 'CA'
                      ? 'federal withholding'
                      : 'your redemption amount'}
                    .
                  </span>
                </span>
              </span>
            )}
          </li>
          <>
            <If
              test={
                state !== 'CT' &&
                state !== 'MI' &&
                state !== 'MN' &&
                state !== 'OK' &&
                state !== 'AR'
              }
            >
              <li className="state-income-tax-disclosure-item">
                <StateNotes
                  userState={state}
                  mandatoryWithholdingStates={mandatoryWithholdingStates}
                  nonMandatoryWithholdingStates={nonMandatoryWithholdingStates}
                />{' '}
                If you elected out of federal income tax withholding but would
                like state income tax withholding, please{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                >
                  contact us
                </a>
                .
              </li>
            </If>
            <If
              test={
                state === 'MI' ||
                state === 'MN' ||
                state === 'CT' ||
                state === 'OK'
              }
            >
              <li className="state-income-tax-disclosure-item">
                You can elect out of the{' '}
                {state === 'CT' ? 'state' : 'default state'} withholding by
                contacting us and processing the transaction by phone.{' '}
                {state === 'OK' ? 'Default withholding ' : 'Withholding '}
                will not occur on direct rollovers. You will be required to
                submit Form{' '}
                {state === 'MI'
                  ? 'MI W-4P'
                  : state === 'MN'
                  ? 'W-4MNP'
                  : state === 'CT'
                  ? 'CT-W4P'
                  : 'OK-W-4-R'}{' '}
                to elect out of withholding for{' '}
                {state === 'CT'
                  ? 'distributions other than '
                  : 'other distributions including '}
                a conversion from a Traditional IRA to Roth IRA.
              </li>{' '}
            </If>
            <If test={state === 'MI' || state === 'MN' || state === 'OK'}>
              <li className="state-income-tax-disclosure-item">
                If you continue your transaction online we will treat that as an
                election to withhold {fullStateName(state)} income tax on any
                type of distribution except a rollover.
              </li>
            </If>
            <If test={state === 'CT'}>
              <li className="state-income-tax-disclosure-item">
                If you continue your transaction online, we will treat that as
                an election to withhold Connecticut income tax on any type of
                distribution except a rollover.
              </li>
            </If>
            <If test={state === 'AR'}>
              <StateNotes
                userState={state}
                mandatoryWithholdingStates={mandatoryWithholdingStates}
                nonMandatoryWithholdingStates={nonMandatoryWithholdingStates}
              />
            </If>
          </>
        </If>

        <If test={state === 'IA'}>
          <li className="state-income-tax-disclosure-item">
            Your IRA is associated with an address in{' '}
            <span className="state-income-tax-disclosure-leader">
              {fullStateName(state)}
            </span>
            <span>
              . If over the age of 55 or disabled, state withholding is not
              required. If you do not want to have IA income tax withholding
              apply please{' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${config.url}/personal-investing/help/contact/index.html`}
              >
                contact us
              </a>{' '}
              to process your trade.
            </span>
          </li>
          <li className="state-income-tax-disclosure-item">
            If you continue processing your distribution online we will treat
            that as an election to withhold Iowa income tax at a rate of{' '}
            {stateRules.percent}%.
          </li>
        </If>
      </ul>
      <If test={!isSalesforceRepMessage}>
        <Button
          id="state-withholding-modal-close"
          buttonType="primary"
          className="btn-trp-primary state-income-tax-disclosure-ok-button e2e-state-tax-withholding-modal-ok-button"
          onClick={closeStateIncomeTaxDisclosure}
        >
          <b>OK</b>
        </Button>
      </If>
    </div>
  );
};

export default StateIncomeTaxDisclosure;
